import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ISelectOption } from 'app/domains/shared/components/select/models/select-option.interface';
import { ISelectSettings } from 'app/domains/shared/components/select/models/select-settings.interface';
import {
  EnumNivelVisualizacaoResultadoPedido,
  NIVEL_VISUALIZACAO_RESULTADO_PEDIDO_DESCRIPTIONS
} from '../../enums/nivel-visualizacao-resultado-pedido.enum';

@Component({
  selector: 'sgt-select-usuario-nivel-visualizacao-pedido-drp',
  templateUrl: './select-usuario-nivel-visualizacao-pedido-drp.component.html'
})
export class SelectUsuarioNivelVisualizacaoPedidoDrpComponent implements OnInit {
  options: ISelectOption[] = [];

  @Input() value: EnumNivelVisualizacaoResultadoPedido;
  @Input() selectorSettings: Partial<ISelectSettings> = {};

  @Output() changed = new EventEmitter<number>();

  settings: Partial<ISelectSettings>;

  ngOnInit(): void {
    this.options = this.buildOptions();
    this.settings = {
      placeholder: 'Selecione o nível de acesso',
      isClearSelectionAllowed: false,
      ...this.selectorSettings
    };
  }

  private buildOptions(): ISelectOption[] {
    return (
      Object.values(EnumNivelVisualizacaoResultadoPedido).filter(
        (v) => typeof v === 'number'
      ) as EnumNivelVisualizacaoResultadoPedido[]
    ).map((nivel) => ({
      id: nivel,
      label: NIVEL_VISUALIZACAO_RESULTADO_PEDIDO_DESCRIPTIONS[nivel].nome
    }));
  }

  get descricaoNivelSelecionado(): string {
    if (this.value === null || this.value === undefined) {
      return '';
    }
    return NIVEL_VISUALIZACAO_RESULTADO_PEDIDO_DESCRIPTIONS[this.value]?.descricao ?? '';
  }

  onChanged(option: ISelectOption): void {
    this.changed.emit(Number(option.id));
  }
}
